var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ padding: '0 0 32px 32px' })},[_c('h4',{style:({ marginBottom: '20px' })},[_vm._v(_vm._s(_vm.title))]),_c('v-chart',{attrs:{"height":_vm.height,"width":_vm.width,"data":_vm.data,"forceFit":true,"padding":['auto', 'auto', '40', '50']}},[_c('v-tooltip'),_c('v-axis'),_c('v-bar',{attrs:{"position":"x*y"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }